// src/index.js
import React from "react";
import "./index.css"; // Global styles
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

// Mengabaikan ResizeObserver error yang tidak berbahaya agar tidak memunculkan overlay di UI
window.addEventListener('error', e => {
  if (
    e.message === 'ResizeObserver loop limit exceeded' ||
    e.message === 'ResizeObserver loop completed with undelivered notifications.'
  ) {
    const resizeObserverErrDiv = document.getElementById(
      'webpack-dev-server-client-overlay-div'
    );
    const resizeObserverErr = document.getElementById(
      'webpack-dev-server-client-overlay'
    );
    if (resizeObserverErr) {
      resizeObserverErr.setAttribute('style', 'display: none');
    }
    if (resizeObserverErrDiv) {
      resizeObserverErrDiv.setAttribute('style', 'display: none');
    }
    e.stopImmediatePropagation();
  }
});
const { pathname, search, hash } = window.location;
if (pathname !== "/" && pathname !== "/index.html") {
  // If we have a hash, it's likely the correct router path, so we drop the pathname.
  // If no hash, we assume the pathname was the intended route.
  const target = hash ? "/" + hash : "/#" + pathname + search;
  window.location.replace(target);
}

ReactDOM.render(
  <HashRouter>
    <App />
  </HashRouter>,
  document.getElementById("root")
);

serviceWorker.unregister();
